import Axios from 'axios'
import Qs from 'qs'
import UUID from 'uuid'

/**
 * 杂项方法
 * url解析通用请求等
 */
export const MiscUtil = {
    // 默认值
    appPath: '',
    proxyUrl: '',

    /**
     * 获取应用路径
     * @param {String} url
     */
    getAppPath(url) {
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url
        }
        const {protocol, host} = window.location
        const webSiteUrl = protocol + '//' + host + this.appPath + '/' + url
        return webSiteUrl
    },

    /**
     * 获取proxyUrl
     * @param {*} url
     */
    getProxyUrl(url = '') {
       return this.getAppPath(this.proxyUrl + url)
    },


    /**
     * 获取URL问号后面的值
     * @return 返回指定key的value
     */
    getParam(paramName) {
        var paramValue = null
        var isFound = false
        if (
            window.location.search.indexOf('?') == 0 &&
            window.location.search.indexOf('=') > 1
        ) {
            var arrSource = unescape(window.location.search)
                .substring(1, window.location.search.length)
                .split('&')
            var i = 0
            while (i < arrSource.length && !isFound) {
                if (arrSource[i].indexOf('=') > 0) {
                    if (
                        arrSource[i].split('=')[0].toLowerCase() ==
                        paramName.toLowerCase()
                    ) {
                        paramValue = arrSource[i].split('=')[1]
                        isFound = true
                    }
                }
                i++
            }
        }
        return paramValue
    },

    /**
     * 远程调用获取服务器数据
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async fetch(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.request(
            merge2Obj(
                {
                    url: this.getAppPath(URL),
                    method: 'post',
                },
                opt_options
            )
        ).then(res => {
            // code message data flag
            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },

    /**
     * 远程调用获取服务器数据
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async fetchGoladmin(URL) {
        URL = String.prototype.trim.call(URL)
        return Axios.request(
            merge2Obj(
                {
                    url: this.getProxyUrl(URL),
                    method: 'post',
                },
            )
        ).then(res => {

            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },

    /**
     * 远程调用获取服务器数据  post json参数
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async fetchByJson(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.post(
            this.getAppPath(URL),
            JSON.stringify(opt_options),
            {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8 '
                }
            }
        ).then(res => {
            return res.data
        })
    },
    /**
     * 远程调用获取服务器数据  post json参数
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async fetchPost(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        let config = {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        };
        return Axios.post(URL,
            opt_options,
            config).then((res) => {
            return res.data
        })
        /*return Axios({
            url: URL,
            method: 'post',
            data: opt_options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            return res.data
        })*/
    },
    /**
     * 远程调用获取服务器数据  post 参数Id
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async fetchByID(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.post(
            this.getAppPath(URL),
            opt_options,
        ).then(res => {
            return res.data
        })
    },

    /**
     * 代理请求
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async getDSWithPorxy(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.get(this.getAppPath(URL), opt_options).then(res => {
            // code message data flag
            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },

    async getDSWithPorxy1(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.get(this.getProxyUrl(URL), opt_options).then(res => {
            // code message data flag
            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },
    async fetchGetRequest(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.get(URL, opt_options).then(res => {
            // code message data flag
            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },

    /**
     * 代理请求 矢量切片服务跨域  临时处理
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async getDSWithPorxyByVTS(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.get(this.getProxyUrl(URL), opt_options).then(res => {
            // code message data flag
            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },


    /**
     * 远程调用获取服务器数据  顺丰地名地址服务
     * @param {String} URL
     * @param {AxiosRequestConfig} opt_options
     */
    async fetchSF(URL, opt_options = null) {
        URL = String.prototype.trim.call(URL)
        return Axios.get(this.getProxyUrl(merge2ObjBySF(URL, opt_options))).then(res => {
            // code message data flag
            const {data, flag} = res.data
            if ((flag === true || flag === false) && data !== undefined) {
                return JSONParse(data)
            }
            // other response
            return res.data
        })
    },

    /**
     *  批量上传图片
     * @param files
     * @returns {Promise<AxiosResponse<any> | never>}
     */
    updateFiles(URL,files) {
        let formData = new FormData()
        files.forEach(f => {
            formData.append("files",f.Blob, f.name)
        })

        let config = {
            headers: {'Content-Type': 'multipart/form-data'}
        };  //添加请求头
        return Axios.post(this.getAppPath(URL), formData, config).then(res => {
            return res.data
        })
    },

    /**
     *  批量下载图片压缩包
     * @param URL
     * @param files
     */
    downloadFilesZip(URL,opt_options){
        URL = String.prototype.trim.call(URL)
        return Axios.post(
            this.getAppPath(URL),
            JSON.stringify(opt_options),
            {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8 '
                }
            }
        ).then(res => {
            return res.data
        })
    },

    /**
     * 下载文件
     * @param {*} obj
     * @param {*} fileName
     */
    download(obj, fileName) {
        let blobObj

        // 字符串文字过大造成的下载bug
        if (typeOf(obj) === 'string') {
            const binStr = atob(obj.split(',')[1] || obj.split(',')[0]),
                len = binStr.length,
                arr = new Uint8Array(len)

            for (var i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i)
            }
            obj = new Blob([arr])
        }

        if (obj instanceof Blob) {
            if (obj.size === 0) {
                throw '文件下载：空数据！'
            }
            blobObj = URL.createObjectURL(obj)
        } else {
            throw '不支持的文件下载！'
        }

        // 兼容Ie（不一定有效）
        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blobObj, fileName)
            URL.revokeObjectURL(blobObj)
        }
        // 主流浏览器
        else {
            // 生成a标签，指定文件名
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = blobObj
            link.download = fileName
            document.body.appendChild(link)
            link.click()

            // 释放资源
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
        }
    },
    /**
     * 唯一id
     */
    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
            .replace(/[xy]/g, function (c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8
                return v.toString(16)
            })
            .toUpperCase()
    },
}

/**
 * 过滤排序
 * @param {Array.<Object>} base
 * @param {Array.<String>} parm
 * @param {String} key
 */
export function filterSort(base, parm = [], key = 'id') {
    if (typeOf(base) === 'array' && base.length) {
        return base
            .filter(c => parm.includes(c[key]))
            .sort(
                (pre, next) => parm.indexOf(pre[key]) - parm.indexOf(next[key])
            )
    }
    return []
}

/**
 *   顺丰服务 参数重组
 * @param url
 * @param obj
 * @returns {*}
 */
export function merge2ObjBySF(url, obj) {
    for (let i in obj) {
        if (url.indexOf('?') != -1) {
            url += '&' + i + '=' + obj[i]
        } else {
            url += '?' + i + '=' + obj[i]
        }
    }
    return url
}


/**
 * 对象深层合并
 * @param {Object} def
 * @param {Object} obj
 */
export function merge2Obj(def, obj) {
    if (!obj) {
        return def
    } else if (!def) {
        return obj
    }

    for (let i in obj) {
        // if its an object
        if (obj[i] != null && obj[i].constructor == Object) {
            def[i] = merge2Obj(def[i], obj[i])
        }
        // if its an array, simple values need to be joined. Object values need to be remerged.
        else if (
            obj[i] != null &&
            obj[i] instanceof Array &&
            obj[i].length > 0
        ) {
            // test to see if the first element is an object or not so we know the type of array we're dealing with.
            if (obj[i][0].constructor == Object) {
                let newobjs = []
                // create an index of all the existing object IDs for quick access. There is no way to know how many items will be in the arrays.
                let objids = {}
                for (let x = 0, l = def[i].length; x < l; x++) {
                    objids[def[i][x].id] = x
                }

                // now walk through the objects in the new array
                // if the ID exists, then merge the objects.
                // if the ID does not exist, push to the end of the def array
                for (let x = 0, l = obj[i].length; x < l; x++) {
                    let newobj = obj[i][x]
                    if (objids[newobj.id] !== undefined) {
                        def[i][x] = mergeObjs(def[i][x], newobj)
                    } else {
                        newobjs.push(newobj)
                    }
                }

                for (let x = 0, l = newobjs.length; x < l; x++) {
                    def[i].push(newobjs[x])
                }
            } else {
                for (let x = 0; x < obj[i].length; x++) {
                    let idxObj = obj[i][x]
                    if (def[i] && def[i].indexOf(idxObj) === -1) {
                        def[i].push(idxObj)
                    }
                }
            }
        } else {
            def[i] = obj[i]
        }
    }
    return def
}

/**
 * 多个对象深层合并
 * @param  {...any} rest
 */
export function mergeObjs(...rest) {
    return rest.reduce((preObj, currentObj) => merge2Obj(preObj, currentObj))
}

/**
 * json解析
 * @param {*} json
 */
export function JSONParse(json) {
    if (typeOf(json) === 'object') {
        for (const key in json) {
            const item = json[key]
            json[key] = JSONParse(item)
        }
    }
    if (typeOf(json) === 'array') {
        for (let i = 0; i < json.length; i++) {
            const item = json[i]
            json[i] = JSONParse(item)
        }
    }
    if (typeOf(json) === 'string') {
        try {
            const parse = JSON.parse(json)
            if (typeOf(parse) === 'object' || typeOf(parse) === 'array') {
                json = JSONParse(parse)
            } else {
                return json
            }
        } catch (error) {
            return json
        }
    }
    return json
}

/**
 * 补全对象配置
 * @param {Object} config 原对象
 * @param {Object} templateObj 模板对象
 */
export function mergeConfig(config, templateObj) {
    // 非Object对象，返回deepCopy
    if (typeOf(templateObj) !== 'object') {
        return deepCopy(config)
    }
    for (const key of Object.keys(templateObj)) {
        if (!config.hasOwnProperty(key)) {
            config[key] = templateObj[key]
        }
    }
    for (const key of Object.keys(config)) {
        if (!templateObj.hasOwnProperty(key)) {
            delete config[key]
        }
    }
    return config
}

/**
 * typeOf
 * @param {*} obj
 */
export function typeOf(obj) {
    const toString = Object.prototype.toString
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    }
    return map[toString.call(obj)]
}

/**
 * 对象深赋值
 * @param {Object} data
 */
export function deepCopy(
    data,
    {valueProcessors = [], keyProcessors = [], ignores = []} = {}
) {
    const t = typeOf(data)
    let o

    if (t === 'array') {
        o = []
    } else if (t === 'object') {
        o = {}
    } else {
        return data
    }

    if (t === 'array') {
        for (let i = 0; i < data.length; i++) {
            o.push(
                deepCopy(data[i], {
                    keyProcessors,
                    valueProcessors,
                    ignores
                })
            )
        }
    } else if (t === 'object') {
        for (let i in data) {
            // ignores
            if (ignores.includes(i)) {
                o[i] = data[i]
                continue
            }
            // key
            let key = i
            keyProcessors.forEach(processor => {
                key = processor(key)
            })
            // data
            let _data = data[i]
            valueProcessors.forEach(processor => {
                _data = processor(_data, key)
            })
            // 已经处理过的数据，不再copy
            o[key] =
                _data === data[i]
                    ? deepCopy(_data, {
                        keyProcessors,
                        valueProcessors,
                        ignores
                    })
                    : _data
        }
    }
    return o
}

/**
 * 检查对象有效性
 * @param  {...any} rest
 */
export function checkValues(...rest) {
    let flag = true

    for (const v of rest) {
        const t = typeOf(v)

        if (t === 'array') {
            flag = v.length > 0
        } else if (t === 'number') {
            flag = Number.isFinite(v)
        } else if (t === 'string') {
            flag = v.trim() !== ''
        } else {
            flag = !!v
        }
        if (!flag) {
            return false
        }
    }
    return true
}

/**
 * @description: 数组转为树结构
 * @param {Array} source  
 * @param {String} root  根节点id名称
 * @param {String} id
 * @param {String} pId
 * @return {*}
 */
 export function dataToTree(source = [], root = "", id = "id", pId = "parentId") {
    return source.filter((parent) => {
        let branchArr = source.filter((child) => {
            return parent[id] == child[pId]
        });
        if (branchArr.length > 0) {
            parent.children = branchArr;
        } else {
            parent.children = [];
            parent.checked = true
        }
        return parent[pId] == root;
    });
}

/**
 * 检查是否为空
 * @param  {any} v
 */
 export function isEmpty(v) {
    const t = typeOf(v)
    let flag
    if (t === 'array') {
        flag = v.length > 0
    } else if (t === 'number') {
        flag = Number.isFinite(v)
    } else if (t === 'string') {
        flag = v.trim() !== ''
    } else if (t === 'object') {
        flag = Object.keys(v).length > 0
    } else {
        flag = !!v
    }
    return !flag
}